import React, { useState } from "react";
import styles from "./App.module.css";
import Form from "./components/Form/Form";
import Header from "./components/Header/Header";
import Table from "./components/Table/Table";

function App() {
  const [data, setData] = useState([]);
  const calculateHandler = (userInput) => {
    // Should be triggered when form is submitted ==> DONE
    // You might not directly want to bind it to the submit event on the form though...
    const yearlyData = []; // per-year results

    let currentSavings = +userInput["currentSavings"]; // feel free to change the shape of this input object!
    const yearlyContribution = +userInput["yearlyContribution"]; // as mentioned: feel free to change the shape...
    const expectedReturn = +userInput["expectedReturn"] / 100;
    const duration = +userInput["duration"];

    // The below code calculates yearly results (total savings, interest etc)
    for (let i = 0; i < duration; i++) {
      const yearlyInterest = currentSavings * expectedReturn;
      currentSavings += yearlyInterest + yearlyContribution;
      yearlyData.push({
        // feel free to change the shape of the data pushed to the array!
        year: i + 1,
        yearlyInterest: yearlyInterest,
        savingsEndOfYear: currentSavings,
        yearlyContribution: yearlyContribution,
      });
    }

    setData(yearlyData);
  };

  return (
    <div>
      <Header />
      <Form onHandleSubmit={calculateHandler} />
      {data.length === 0 && (
        <p className={styles.found}>No investment calculated yet!</p>
      )}

      {data.length > 0 && <Table data={data} initial={1000} />}
    </div>
  );
}

export default App;
